var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3327 23.5H7.16602V13H19.9993L22.3327 23.5Z",
    fill: "#C7CED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1883 31.1883L9.5 23.5L20 13L27.6883 20.6883C28.1229 21.1255 28.3668 21.7169 28.3668 22.3333C28.3668 22.9498 28.1229 23.5412 27.6883 23.9783L20.4783 31.1883C20.0412 31.6229 19.4498 31.8668 18.8333 31.8668C18.2169 31.8668 17.6255 31.6229 17.1883 31.1883Z",
    fill: "#C7CED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1965 11.016C22.6421 10.7952 22.0242 10.7952 21.4698 11.016L16.6398 12.9993C16.3628 13.1029 16.1104 13.2631 15.8989 13.4698C15.6874 13.6766 15.5215 13.9252 15.4116 14.1997C15.3018 14.4743 15.2505 14.7688 15.2611 15.0644C15.2717 15.3599 15.3439 15.65 15.4731 15.916C15.7278 16.461 16.183 16.8865 16.7438 17.1039C17.3047 17.3213 17.9278 17.3137 18.4831 17.0827L22.3331 15.3327L27.6881 20.6877C28.1227 21.1249 28.3667 21.7162 28.3667 22.3327C28.3667 22.9491 28.1227 23.5405 27.6881 23.9777L25.8331 25.8327H32.8331V10.666L28.1665 12.9993L23.1965 11.016Z",
    fill: "#6B758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product_icon.3e49fed6574f5c92419ce35face1bd1b.svg";
export { ForwardRef as ReactComponent };